import React from "react";
import { DisplayPercentageCell } from "components/display/percentage";
import { List } from "components";

export default function DepartmentList({ filters, setListData, setOrgData }) {
  const columns = [
    {
      id: "department",
      accessorKey: "department",
      header: "Department",
      cell: ({ getValue }) => {
        return <span className="capitalize font-medium">{getValue().name}</span>;
      },
    },
    {
      id: "acknowledged_percentage",
      accessorKey: "x",
      header: "Acknowledged (%)",
      cell: DisplayPercentageCell,
    },
    {
      id: "Utilization",
      accessorKey: "y",
      header: "Utilization (%)",
      cell: DisplayPercentageCell,
    },
  ];

  return (
    <div>
      <List
        key={JSON.stringify(filters)}
        storageKey={`timesheet-analytics-departments-${JSON.stringify(filters)}`}
        endPoint="flow"
        columns={columns}
        hidePagination={true}
        onResponseChange={(response) => {
          setListData(response?.raw?.chartData || []);
          setOrgData(response?.raw?.organizationAverage);
        }}
        meta={{
          flowId: "3fde7bc1-fe69-488f-8684-d619a3c18e76",
          itemKey: "chartData",
        }}
        showSearch={false}
        filters={filters}
        className="pt-0"
        showListHeader={false}
      />
    </div>
  );
}
